module.exports = __webpack_public_path__ + "img/corsymo_logo.53d8d0a6.png";